import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "../TandemTypes";

export type ProfileListPayload = {
  num_profiles: number;
  slot1: number;
  slot2: number;
  slot3: number;
  slot4: number;
  slot5: number;
  slot6: number;
};

export type ProfileListEvent = {
  numProfiles: number;
  slot1: number;
  slot2: number;
  slot3: number;
  slot4: number;
  slot5: number;
  slot6: number;
};

const profileListSchema = z.object({
  num_profiles: z.number(),
  slot1: z.number(),
  slot2: z.number(),
  slot3: z.number(),
  slot4: z.number(),
  slot5: z.number(),
  slot6: z.number(),
});

export const LID_IDP_LIST = {
  value: 0x47,
  name: "Personal Profile List Event",
  format: "b...bbbbbb......",
  fields: ["num_profiles", "slot1", "slot2", "slot3", "slot4", "slot5", "slot6"],
  postprocess: rec => ({
    ...rec,
    numProfiles: rec.num_profiles,
  }),
  schema: profileListSchema,
} as const satisfies TandemEventDefinition<ProfileListPayload, ProfileListEvent>;
